<!-- Heading -->
<mdb-card class="mb-4 wow fadeIn">
  <mdb-card-body class="d-flex flex-wrap justify-content-between align-items-center p-2 m-2">
    <div class="md-form col-sm-12 col-md-2 col-lg-2 m-1">
      <input
        [(ngModel)]="transactionSearchRequest.searchTerm"
        mdbInput
        name="searchTerm"
        type="text"
        (keyup.enter)="SearchTrades()"
        id="searchTerm"
        class="form-control"
        #searchTerm="ngModel"
        required
      />
      <label for="searchTerm">Search</label>
    </div>
    <div class="md-form col-sm-12 col-md-2 col-lg-2 m-1">
      <select
        class="md-form form-control browser-default w-100"
        id="status"
        [(ngModel)]="transactionSearchRequest.transactionStatusId"
        placeholder="Status"
        (change)="SearchTrades()"
      >
        <option *ngFor="let status of filterStatuses" [ngValue]="status.id">
          {{ status.name }}
        </option>
      </select>
      <label for="status" class="active">Trade Status</label>
    </div>
    <div class="col-sm-12 col-md-2 col-lg-2 m-1">
      <mdb-checkbox class="browser-default w-100" checked="true" [(ngModel)]="transactionSearchRequest.todaysTradesOnly"
        >Today's Trades Only</mdb-checkbox
      >
    </div>
    <div *ngIf="this.badStatusCounts.length > 0" class="d-flex flex-column align-items-center col-sm-12 col-md-auto m-1">
      <div *ngFor="let bad of this.badStatusCounts">
        <mdb-badge [color]="getBadgeColorForStatus(bad.statusId)" class="mb-1">{{ bad.count }} {{ getStatusName(bad.statusId) }}</mdb-badge>
      </div>
    </div>
    <div class="col-sm-12 col-md-2 col-lg-2 text-right m-1">
      <button mdbBtn size="sm" class="btn-trakly-action" mdbWavesEffect (click)="SearchTrades()">Search</button>
    </div>
  </mdb-card-body>
</mdb-card>
<mdb-card cascade="true" narrower="true" class="mt-3">
  <div
    id="user-trades-sticky"
    class="sticky-top view view-cascade gradient-card-header blue-gradient narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
  >
    <p class="white-text mx-3 my-auto">Current Trades</p>
    <div>
      <div class="col-12 text-center" *ngIf="downloadBusy">
        <span>Downloading...</span>
        <span class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </span>
      </div>
      <div *ngIf="!downloadBusy">
        <button
          type="button"
          mdbBtn
          color="white"
          outline="true"
          rounded="true"
          size="sm"
          class="px-2"
          mdbWavesEffect
          (click)="DownloadFiles(true)"
        >
          <mdb-icon fas icon="cloud-download-alt" class="mt-0"></mdb-icon>
          Download All
        </button>
        <button
          type="button"
          mdbBtn
          color="white"
          outline="true"
          rounded="true"
          size="sm"
          class="px-2"
          mdbWavesEffect
          (click)="DownloadFiles(false)"
        >
          <mdb-icon fas icon="cloud-download-alt" class="mt-0"></mdb-icon>
          Download Selected
        </button>
        <button
          type="button"
          mdbBtn
          color="white"
          outline="true"
          rounded="true"
          size="sm"
          class="px-2"
          mdbWavesEffect
          (click)="copyPinsAndUsd()"
          [disabled]="displayRows.length === 0"
        >
          <mdb-icon fas icon="copy" class="mt-0"></mdb-icon> Copy pins & USD
        </button>
        <button
          type="button"
          mdbBtn
          color="white"
          outline="true"
          rounded="true"
          size="sm"
          class="px-2"
          mdbWavesEffect
          (click)="Extract('InProgressTransactions')"
        >
          <mdb-icon fas icon="cloud-download-alt" class="mt-0"></mdb-icon> Extract
        </button>
      </div>
    </div>
  </div>

  <div class="px-4">
    <div class="col">
      <div *ngIf="showError && !busy" class="alert alert-danger text-center font-weight-bold" role="alert">
        {{ errorMsg }}
      </div>
      <div *ngIf="copyPinsMessage && !busy" class="alert alert-success text-center" role="status">
        {{ copyPinsMessage }}
      </div>
    </div>
    <div class="table-responsive" *ngIf="!busy">
      <!--Table-->
      <table class="table table-sm table-hover" id="InProgressTransactions">
        <thead>
          <tr>
            <th scope="col" class="text-left"></th>
            <th scope="col" class="text-left">Full Name</th>
            <th scope="col" class="text-center">Trade Amount</th>
            <th scope="col" class="text-center">Breakdown</th>
            <th scope="col" class="text-center"></th>
            <th scope="col" class="text-center">Status</th>
            <th scope="col" class="text-center">Documents</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of displayRows; trackBy: trackByTradeId">
            <td class="text-center">
              <input
                type="checkbox"
                class="mt-2"
                [name]="'sel-' + row.id"
                [(ngModel)]="row.trade.selected"
                [disabled]="!row.hasDocs"
              />
            </td>
            <td class="text-left">
              <span [attr.title]="row.infoText">{{ row.trade.fullName }}</span>
            </td>
            <td class="text-center">R {{ row.trade.amountSent | number }}</td>
            <td class="breakdown-cell">
              <div class="breakdown-line" *ngFor="let line of row.breakdownLines; trackBy: trackByBreakdownId">
                <span class="breakdown-pin">{{ line.pin }}</span>
                <span class="breakdown-usd">{{ line.usd }}</span>
              </div>
            </td>
            <td class="text-center">
              <span
                *ngIf="row.canEditFia"
                (click)="onEditFiaPins(row.trade)"
                class="clickable fas fa-pen-to-square actionIcon"
                title="Edit FIA Pins and SDA"
              ></span>
            </td>
            <td class="centeredCell">
              <div style="display: inline-block">
                <span class="statusBlock" [ngClass]="row.statusClass">
                  <span [attr.title]="row.statusHelp">{{ row.statusName }}</span>
                </span>
              </div>
            </td>

            <td class="text-center">
              <div class="btn-group" mdbDropdown *ngIf="row.hasDocs">
                <button type="button" mdbBtn class="dropdown-toggle waves-light btn-sm btn-trakly" mdbDropdownToggle mdbWavesEffect>
                  Supporting Docs
                </button>
                <div class="dropdown-menu">
                  <a class="dropdown-item" *ngFor="let doc of row.trade.supportingMedia" (click)="DownloadFile(doc.id)">
                    <span *ngIf="doc.fileType == 'Transaction Withdrawl Confirmation'">
                      Source of funds ({{ doc.createdDate | date: "dd-MM-yyyy" }})
                    </span>
                    <span *ngIf="doc.fileType == 'Trade Source Of Funds'"> Trade Source Of Funds </span>
                    <span *ngIf="doc.fileType == 'Sars Communication - FIA TCS Pin Issued'"> FIA pin </span>
                    <span *ngIf="doc.fileType == 'Broker FIA Merge Document'"> Split Trade </span>
                    <span *ngIf="doc.fileType == 'Crypto Declaration'"> Crypto Declaration </span>
                    <span *ngIf="doc.fileType == 'Marriage Certificate'"> Marriage Certificate </span>
                  </a>
                </div>
              </div>
              <span *ngIf="!row.hasDocs"> No documents found </span>
            </td>
          </tr>
          <tr *ngIf="displayRows.length === 0">
            <td colspan="7" class="text-center text-muted py-4">Nothing found</td>
          </tr>
        </tbody>
      </table>
      <!--Table-->
    </div>
  </div>
  <!--Loading-->
  <div class="col-12 text-center" *ngIf="busy">
    <div *ngIf="busy" class="spinner-grow text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</mdb-card>

<app-trade-edit
  [(showModal)]="showTradeEditModal"
  [(transaction)]="selectedTransaction"
  [(deal)]="selectedTransactionDeal"
  [(status)]="selectedTransactionStatus"
  [(fullStatusList)]="transactionStatuses"
  (onModelChange)="updateOriginalTrade($event)"
  (onError)="handleModalError($event)"
></app-trade-edit>

<app-transaction-fia-sda-edit
  [(showModal)]="showFiaSdaEditModal"
  [transaction]="selectedTransaction"
  (onModelChange)="updateOriginalTradeFromFiaSdaEdit($event)"
  (onError)="popupError($event)"
></app-transaction-fia-sda-edit>

<error-component [error]="errorResponse" [(showModal)]="showModalError"></error-component>
